var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "email-listing-delete-confirm-dialog",
      attrs: {
        visible: _vm.showModal,
        size: "small",
        title: _vm.$t.__("email.EmailListing.deleteConfirmModal.title"),
        closeOnClickOverlay: false,
        primaryAction: {
          label: _vm.$t.__("common.actions.confirm"),
          loading: _vm.isLoading,
          type: "primary-destructive",
          action: function() {
            return _vm.handleConfirm()
          }
        },
        secondaryActions: [
          {
            label: _vm.$t.__("common.actions.cancel"),
            action: function() {
              _vm.$emit("close")
            }
          }
        ]
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: _vm.closeModal
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("p", {
          staticClass:
            "typographies-paragraph-medium-regular email-listing-delete-confirm-dialog__description",
          domProps: {
            innerHTML: _vm._s(
              _vm.$t.__("email.EmailListing.deleteConfirmModal.description", {
                emailSubject: _vm.email.subject
              })
            )
          }
        })
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }